import React from "react";
import styled from "styled-components";
import DownloadButton from "../Button/DownloadButton";
import { AiFillCloseCircle } from "react-icons/ai";
import downloadEnglish from "../../assets/resumes/William Cordeiro Resume  EN.pdf";
import downloadPortuguese from "../../assets/resumes/William Cordeiro Resume PT.pdf";

function Popup({ open, buttonClick }) {
  return (
    <Container>
      <div>
        <div className={open ? "inner-modal inner-modal-open" : "inner-modal"}>
          <div
            className={
              open ? "content-wrapper content-open" : "content-wrapper"
            }
          >
            <i className="fa fa-times-circle" onClick={() => buttonClick()}>
              <AiFillCloseCircle />
            </i>
            <h3 className="dawnload-title">
              Choose the language of your preference
            </h3>
            <div className="dawnload-buttons">
              <DownloadButton children="English" href={downloadEnglish} />
              <DownloadButton children="Portuguese" href={downloadPortuguese} />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default Popup;

const Container = styled.div`
  #modal-button {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -100px;
  }

  .dawnload-title {
    margin-top: 2rem;
  }

  .dawnload-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5rem;
    margin-top: 5rem;
  }

  .inner-modal {
    position: absolute;
    z-index: 1;
    height: 15px;
    width: 15px;
    border-radius: 12px;
    background-color: white;
    background-size: cover;
    transition: all 350ms cubic-bezier(0.68, -0.55, 0.265, 1.18);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }

  .inner-modal-open {
    position: absolute;
    height: auto;
    width: 500px;
    background-color: white;
    background-size: cover;
    border-radius: 7px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    -webkit-transition: all 300ms cubic-bezier(0.68, -0.165, 0.265, 1.55);
  }

  .content-wrapper {
    padding: 20px;
    text-align: center;
    visibility: visible;
    opacity: 0;
  }

  .content-open {
    visibility: visible;
    opacity: 1;
    -webkit-transition: all 0.3s ease-out 350ms;
  }

  .fa-times-circle {
    z-index: 1;
    font-size: 35px;
    color: var(--color-black);
    float: right;
    transition: opacity 0.3s;
    cursor: pointer;
  }

  .fa-times-circle:hover {
    animation: pulse2 0.3s 2;
  }

  .modal-content {
    margin-top: 165px;
    font-size: 20px;
  }

  @keyframes pulse2 {
    0% {
      transform: scale(1);
    }
    35% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  @media only screen and (min-width: 320px) {
    .inner-modal-open {
      width: 90%;
      -o-object-fit: cover;
      object-fit: cover;
    }

    .dawnload-buttons {
      display: block;
      margin: 20px;
    }
  }

  @media only screen and (min-width: 768px) {
    .inner-modal-open {
      width: 40%;
    }

    .dawnload-buttons {
      display: block;
      margin: 40px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .inner-modal-open {
      height: auto;
      width: 500px;
    }

    .dawnload-buttons {
      display: flex;
      margin: 0px;
    }
  }
`;
